interface TextFadeProps {
  children: React.ReactNode;
  direction?: 'left' | 'right';
  //gradient?: string;
  className?: string;
}

const TextFade = ({
  direction = 'right',
  children,
  //gradient = '-webkit-linear-gradient(69deg, #ffffff 20.44%, #b1b1b140)',
  className = ''
}: TextFadeProps) => (
  <span
    style={{
      background: `-webkit-linear-gradient(${direction === 'left' ? '180deg' : '0deg'}, #ffffff 0%, #b1b1b170 99%)`,
      WebkitTextFillColor: 'transparent',
      WebkitBackgroundClip: 'text'
    }}
    className={className}>
    {children}
  </span>
);

export default TextFade;
